import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

const THEMES = {
  dark: {
    label: 'Dark',
    class: 'theme-dark',
    description: 'Pure dark mode'
  },
  gray: {
    label: 'Gray',
    class: 'theme-gray',
    description: 'Softer dark with gray tones'
  },
  light: {
    label: 'Light',
    class: 'theme-light',
    description: 'Clean light mode'
  }
};

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => {
    try {
      return localStorage.getItem('dmv-theme') || 'light';
    } catch {
      return 'dark';
    }
  });

  useEffect(() => {
    const root = document.documentElement;
    // Remove all theme classes
    Object.values(THEMES).forEach(t => root.classList.remove(t.class));
    // Apply current
    const themeConfig = THEMES[theme];
    if (themeConfig) {
      root.classList.add(themeConfig.class);
    }
    try {
      localStorage.setItem('dmv-theme', theme);
    } catch {}
  }, [theme]);

  const setTheme = (newTheme) => {
    if (THEMES[newTheme]) {
      setThemeState(newTheme);
    }
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, themes: THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
